import initialState from './initialState';
import fileSaver from 'file-saver';
import {
  RECEIVE_PORTFOLIO,
  PAGINATE_PORTFOLIO,
  EXPORT_AND_SAVE_PORTFOLIO,
  HANDLE_PORTFOLIO_ERROR
} from '../actions/actionTypes';

export function portfolio(state = initialState.portfolio, action) {
  switch (action.type) {
    case RECEIVE_PORTFOLIO:
      return action.portfolio;
    case EXPORT_AND_SAVE_PORTFOLIO:
      fileSaver.saveAs(
        new Blob([action.data],
          { type: "text/csv" }),
        "export.csv"
      );
      return state;
    default:
      return state;
  }
}

export function portfolioError(state = initialState.portfolioError, action) {
  switch (action.type) {
    case HANDLE_PORTFOLIO_ERROR:
      return action.portfolioError;
    default:
      return state;
  }
}

export function portfolioPagination(state = initialState.portfolioPagination, action) {
  switch (action.type) {
    case PAGINATE_PORTFOLIO:
      return action.portfolioPagination;
    default:
      return state;
  }
}
